// components/PaginationControl.jsx
import React from 'react';
import { Pagination } from 'react-bootstrap';

const PaginationControl = ({ 
  currentPage, 
  totalPages, 
  onPageChange,
  maxVisiblePages = 7 // Augmentez à 7 pour voir plus de pages
}) => {
  if (totalPages <= 1) return null;

  const getVisiblePages = () => {
    if (totalPages <= maxVisiblePages) {
      // Si moins de pages que le maximum, afficher toutes
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const half = Math.floor(maxVisiblePages / 2);
    let start = currentPage - half;
    let end = currentPage + half;

    // Ajuster si on est près du début
    if (start < 1) {
      start = 1;
      end = maxVisiblePages;
    }
    
    // Ajuster si on est près de la fin
    if (end > totalPages) {
      end = totalPages;
      start = totalPages - maxVisiblePages + 1;
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  const visiblePages = getVisiblePages();

  return (
    <Pagination className="mb-0">
      <Pagination.Prev 
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      />
      
      {/* Toujours afficher la première page */}
      {currentPage > 3 && (
        <>
          <Pagination.Item onClick={() => onPageChange(1)}>
            1
          </Pagination.Item>
          {currentPage > 4 && <Pagination.Ellipsis />}
        </>
      )}
      
      {/* Pages visibles */}
      {visiblePages.map(page => (
        <Pagination.Item
          key={page}
          active={page === currentPage}
          onClick={() => onPageChange(page)}
        >
          {page}
        </Pagination.Item>
      ))}
      
      {/* Toujours afficher la dernière page */}
      {currentPage < totalPages - 2 && (
        <>
          {currentPage < totalPages - 3 && <Pagination.Ellipsis />}
          <Pagination.Item onClick={() => onPageChange(totalPages)}>
            {totalPages}
          </Pagination.Item>
        </>
      )}
      
      <Pagination.Next 
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      />
    </Pagination>
  );
};

export default PaginationControl;